/**
 * @ngdoc run
 * @description Handles the route change error for e-courses, in case of a not found e-course.
 * @param $rootScope
 * @param Alerts
 * @param $state
 */
export default function runBlock($rootScope, Alerts, $state) {
  'ngInject';
  $rootScope.$on('$stateChangeError',
    function (event, toState, toParams) {
      if (toState.name.includes('ecourse') && toParams.slug) {
        Alerts.add({
          type: 'danger',
          message: 'Ecourse not found'
        });
        $state.go('app');
      }
    });
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/ecourse.run.js
 **/